module.exports = "images/high_performance_laptops.webp";